import { render, staticRenderFns } from "./business-opportunities-dialog.vue?vue&type=template&id=528d1159&scoped=true&"
import script from "./business-opportunities-dialog.vue?vue&type=script&lang=js&"
export * from "./business-opportunities-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d1159",
  null
  
)

export default component.exports